module.exports = __webpack_public_path__ + "img/MP.746e6597.svg";